import React, { useState, useEffect } from 'react';

const ProtagsTab = ({ data, onChange }) => {
  const [characterIntro, setCharacterIntro] = useState(data.characterIntro || '');

  useEffect(() => {
    // Update the local state when the external data changes
    setCharacterIntro(data.characterIntro || '');
  }, [data.characterIntro]);

  const handleCharacterIntroChange = (e) => {
    const updatedCharacterIntro = e.target.value;
    setCharacterIntro(updatedCharacterIntro);
    onChange({ characterIntro: updatedCharacterIntro });
  };
  
  return (
    <div className='tab-styling'>
      <div className="nice-form-group">
      <label>Character Introduction</label>
      <textarea value={characterIntro} onChange={handleCharacterIntroChange} />
          </div>
          <p className='synopsis-paragraph'>This is where you introduce this character. Be sure to provide their GOAL and what MOTIVATES them to achieve it. Does she want to find a treasure? Perhaps steal the husband of the Count? What makes this person special?</p>

    </div>
  );
};

export default ProtagsTab;
